<template>
  <div style="padding-bottom: 10vw">
    <div style="position: relative;height: 35.47vw;width: 100%">
      <img src="../assets/img/login/register.png" class="loginImg" />
      <div style="padding-top: 18.8vw;width: 100vw" class="centerBox">
        <div class="centerBox" @click="$router.push('/login')" style="font-size: 4.13vw;color: white;width: 50%">登录</div>
        <div class="centerBox"  style="font-size: 4.13vw;color: #232324;width: 50%">注册</div>
      </div>
    </div>
<!--    <van-radio-group v-model="radio" direction="horizontal" @change="changeRadio" style="width: 72vw;display: flex;margin: 7vw auto 0">-->
<!--      <van-radio :name="1" style="width: 33%;margin: 0;" class="centerBox">-->
<!--        <template slot-scope="scope" slot="icon">-->
<!--          <img :src="scope.checked ? icon.activeIcon : icon.inactiveIcon" style="width: 3.33vw;" />-->
<!--        </template>-->
<!--        店主-->
<!--      </van-radio>-->
<!--      <van-radio :name="2" style="width: 33%;margin: 0" class="centerBox">-->
<!--        <template slot-scope="scope" slot="icon">-->
<!--          <img :src="scope.checked ? icon.activeIcon : icon.inactiveIcon" style="width: 3.33vw;" />-->
<!--        </template>-->
<!--        供应商-->
<!--      </van-radio>-->
<!--      <van-radio :name="3" style="width: 33%;margin: 0" class="centerBox">-->
<!--        <template slot-scope="scope" slot="icon">-->
<!--          <img :src="scope.checked ? icon.activeIcon : icon.inactiveIcon" style="width: 3.33vw" />-->
<!--        </template>-->
<!--        运营商-->
<!--      </van-radio>-->
<!--    </van-radio-group>-->
    <van-form ref="MyForm" class="loginForm" style="margin-top: 16.4vw" :border="false" :show-error="false">
      <div style="" class="centerBox loginFormItem" :class="{active: currentInput === 'userName'}">
        <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginUser.png">
        <van-field
                v-model="form.userName"
                @input="formatSpace('userName')"
                @focus="currentInput = 'userName'"
                @blur="currentInput = ''"
                placeholder="用户名"
                :rules="[{ required: true, message: '请填写用户名' }]"
        ></van-field>
      </div>
      <div style=""  class="centerBox loginFormItem" :class="{active: currentInput === 'passwd'}">
        <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginPass.png">
        <van-field
                v-model="form.passwd"
                type="password"
                @focus="currentInput = 'passwd'"
                @blur="currentInput = ''"
                placeholder="密码"
                :rules="[{ required: true, message: '请填写密码' }, { pattern: /^[0-9A-Za-z]{6,}$/, message: '密码长度需在6到16位之间，且不允许有特殊字符'}]"
        ></van-field>
      </div>
      <div style="" v-if="radio === 2" class="centerBox loginFormItem" :class="{active: currentInput === 'bank'}">
        <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginBank.png">
        <van-field
                v-model="form.orgNo"
                @focus="currentInput = 'bank'"
                @blur="currentInput = ''"
                placeholder="银联商户编号"
                :rules="[{ required: true, message: '请填写银联商户编号' }]"
        ></van-field>
      </div>
      <div style="" v-if="radio === 2" class="centerBox loginFormItem" :class="{active: currentInput === 'people'}">
        <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginPeople.png">
        <van-field
                v-model="form.contactUser"
                @focus="currentInput = 'people'"
                @blur="currentInput = ''"
                placeholder="联系人"
                :rules="[{ required: true, message: '请填写联系人' }]"
        ></van-field>
      </div>
      <div style="" class="centerBox loginFormItem" :class="{active: currentInput === 'tel'}">
        <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginTel.png">
        <van-field
                v-model="form.userTel"
                @focus="currentInput = 'tel'"
                @blur="currentInput = ''"
                :placeholder="radio === 2 ? '联系人电话' : '手机号'"
                :rules="[{ required: true, message: '请填写' + (radio === 2 ? '联系人电话' : '手机号') }, { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的手机号'}]"
        ></van-field>
      </div>
      <div style="" v-if="radio === 2 || radio === 3" class="centerBox loginFormItem" :class="{active: currentInput === 'address'}">
        <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginAddress.png">
        <van-field
                v-model="form.address"
                @focus="currentInput = 'address'"
                @blur="currentInput = ''"
                placeholder="详细地址"
                :rules="[{ required: true, message: '请填写密码' }]"
        ></van-field>
      </div>
      <div style="" v-if="radio === 1" class="centerBox loginFormItem" :class="{active: currentInput === 'code'}">
        <img style="width: 4.53vw;height: 4.4vw" src="../assets/img/login/loginCode.png">
        <van-field
                v-model="form.recommendCode"
                @focus="currentInput = 'code'"
                @blur="currentInput = ''"
                placeholder="邀请码"
                :rules="[{ required: true, message: '请填写邀请码' }]"
        ></van-field>
      </div>
      <div style="margin: 29vw 14vw 0;">
        <van-button round block color="#F45D59"
                    @click="onSubmit"
                    :disabled="!form.isAgreed"
                    type="info" native-type="submit">
          注册
        </van-button>
        <div @click="showDialog = true" v-if="radio === 2 || radio === 1" style="font-size: 3.4vw;color: #797979;margin-top: 4.1vw" class="centerBox">
          <van-checkbox name="1" style="margin-right: 1.7vw" v-model="form.isAgreed" check-color="#0091ff" icon-size="3.4vw"></van-checkbox>
          我已阅读并同意 <div style="color: #0091ff;margin-left: 1.9vw">《加盟商平台入驻协议》</div>
        </div>
      </div>
    </van-form>
    <van-dialog class="diaInfo" title="加盟商平台入驻协议" v-model="showDialog"
                :showConfirmButton="true" confirmButtonText="同意"
                :close-on-click-overlay="false" style="border-radius: 5vw;" :style="{ width: '80%'}">
      <div class="diaInfoContent" v-html="xyText">
      </div>
    </van-dialog>

  </div>
</template>

<script>
  import md5 from 'js-md5';
  import activeIcon from '../assets/img/login/check.png'
  import inactiveIcon from '../assets/img/login/chenkNo.png'
  export default {
    name: 'login',
    data () {
      return {
        showDialog: false,
        checked: false,
        icon: {
          activeIcon,
          inactiveIcon
        },
        currentInput: '',
        form: {
          recommendCode: '',
          userName: '',
          passwd: '',
          userTel: '',
          address: '',
          orgNo: '',
          contactUser: '',
          isAgreed: ''
        },
        xyText: '   您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对协议有任何疑问，可向      咨询。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与   达成一致，成为     平台“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。\n' +
                '一、定义\n' +
                '平台：指鼎汇丰\n' +
                '鼎汇丰平台商家：指申请进入   平台销售商品的经营主体。\n' +
                '鼎汇丰平台服务：基于互联网，以包含   平台网站、客户端等在内的各种形态向您提供的各项服务。\n' +
                '鼎汇丰平台规则：包括在所有XX平台规则频道内已经发布及后续发布的全部规则、解读、公告等内容以及各平台在论坛、帮助中心内发布的各类规则、实施细则、产品流程说明、公告等。\n' +
                '同一用户：使用同一身份认证信息或经   平台排查认定多个账户的实际控制人为同一人的，均视为同一用户。\n' +
                '恶意购物行为：包括恶意下单、恶意购买、恶意差评等，指从事了相关购物行为，但积极主动终止购物目的或结果，或追求一般购物以外的目的或结果，对他人或   平台（可能）造成消极影响的行为。\n' +
                '二、协议范围\n' +
                '2.1 本协议由您与 鼎汇丰 平台经营者共同缔结，本协议对您与  鼎汇丰平台经营者、  鼎汇丰   平台商家均具有合同效力。\n' +
                '2.2 鼎汇丰平台经营者是指经营鼎汇丰平台的各法律主体，您可随时查看鼎汇丰平台各网站首页底部公示的证照信息以确定与您履约的鼎汇丰主体。本协议项下，鼎汇丰平台经营者可能根据鼎汇丰平台的业务调整而发生变更，变更后的鼎汇丰平台经营者与您共同履行本协议并向您提供服务，鼎汇丰平台经营者的变更不会影响您本协议项下的权益。鼎汇丰平台经营者还有可能因为提供新的鼎汇丰平台服务而新增，如您使用新增的鼎汇丰平台服务的，视为您同意新增的鼎汇丰平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。\n' +
                '2.3 由于互联网高速发展，您与鼎汇丰签署的本协议列明的条款并不能完整罗列并覆盖您所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，鼎汇丰平台法律声明及隐私权政策、鼎汇丰平台规则、特殊规定等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用鼎汇丰平台服务，视为您同意上述补充协议。\n' +
                '三、账户注册与使用\n' +
                '3.1 您确认，在您开始注册程序使用鼎汇丰平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。此外，您还需确保您是鼎汇丰超市的加盟商，并在鼎汇丰平台提供相关证明。、\n' +
                '3.2 当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得鼎汇丰平台账户并成为鼎汇丰平台用户。\n' +
                '3.3 您的用户名必须同您的加盟商号一致，注册人必须是加盟商户的法定代表人。 由于您的鼎汇丰账户关联您的个人信息及鼎汇丰平台商业信息，您的鼎汇丰账户仅限您本人使用。未经鼎汇丰平台同意，您直接或间接授权第三方使用您鼎汇丰账户或获取您账户项下信息的行为无效。如鼎汇丰平台判断您鼎汇丰账户的使用可能危及您的账户安全及/或鼎汇丰平台信息安全的，鼎汇丰平台可拒绝提供相应服务或终止本协议。\n' +
                '四、用户管理\n' +
                '4.1 在使用鼎汇丰平台服务时，您应当按鼎汇丰平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便鼎汇丰与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。如果您提供的注册资料不合法、不真实、不准确、不详尽，您须承担因此引起的相应责任及后果，并且鼎汇丰有权注销您的鼎汇丰账户。\n' +
                '4.2 您应当及时更新您提供的信息，在法律有明确规定要求鼎汇丰作为平台服务提供者必须对部分用户（如平台商家等）的信息进行核实的情况下，鼎汇丰将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。如XX按您最后一次提供的信息与您联系未果、您未按鼎汇丰的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及鼎汇丰造成的全部损失与不利后果。鼎汇丰可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部鼎汇丰平台服务，鼎汇丰对此不承担责任。\n' +
                '4.3 您的账户为您自行设置并由您保管，鼎汇丰任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开鼎汇丰平台。\n' +
                '4.4因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，鼎汇丰并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。\n' +
                '4.5 您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。\n' +
                '4.6 如发现任何未经授权使用您账户登录鼎汇丰平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知鼎汇丰。您理解XX对您的任何请求采取行动均需要合理时间，且鼎汇丰应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，鼎汇丰不承担责任。\n' +
                '4.7依据国家相关法律法规规章，用户同意严格遵守以下义务：\n' +
                '（1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；\n' +
                '（2）从中国大陆向境外传输资料信息时必须符合中国有关法律法规；\n' +
                '（3）不得利用本网站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；\n' +
                '（4）不得干扰本网站的正常运转，不得侵入本网站及国家计算机信息系统；\n' +
                '（5）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的、不文明的等信息资料；\n' +
                '（6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；\n' +
                '（7）不得教唆他人从事本条所禁止的行为；\n' +
                '（8）不得利用在本网站注册的账户进行牟利性经营活动（如批发、炒货、转卖）；\n' +
                '（9）不得发布任何侵犯他人著作权、商标权等知识产权及其他合法权利的内容。若您未遵守以上规定的，鼎汇丰有权作出独立判断并采取暂停会员权限直至注销您的鼎汇丰账户等措施，并且您须对自己的言论和行为承担法律责任。\n' +
                '4.10 根据有关法律法规，鼎汇丰在此郑重提请用户注意，任何由用户经由鼎汇丰平台服务以上载、张贴或任何其它方式传送的资讯、资料、文字、照片、图形、信息或其它资料（以下简称"内容"），无论系公开还是私下传送，均由内容提供者、发布者承担责任。在任何情况下，鼎汇丰均不为此类内容负责，包含但不限于此类内容之任何错误或遗漏，以及此类内容衍生之任何损失或损害。但XX有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用我们的服务的全部或部分，保存有关记录，并向有关机关报告。\n' +
                '4.11 鼎汇丰不对用户所发布信息的删除或储存失败承担任何责任，鼎汇丰有权判定您的行为是否符合鼎汇丰平台规则的要求，如果您的行为不符合前述要求，鼎汇丰平台有权终止对您提供服务。\n' +
                '4.12鼎汇丰有权判定用户的行为是否符合中国法律法规的规定以及本服务条款的要求，如果用户违背了中国法律法规的规定或本服务条款的规定，鼎汇丰有权作出独立判断并采取暂停或关闭用户帐号等措施。\n' +
                '五、商品及服务信息\n' +
                '5.1鼎汇丰上的商品及服务宣传、参数价格、数量、是否有货等商品及服务信息随时都有可能发生变动，鼎汇丰不作特别通知。由于网站上商品及服务信息的数量极其庞大，虽然本站会尽最大努力保证您所浏览商品及服务信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，网页显示的信息可能会有一定的滞后性或差错，对此情形您表示知悉并理解，并同意不追究鼎汇丰的违约或侵权责任；如您发现商品及服务信息错误的或有疑问的，请您不要提交订单或接受服务，并在第一时间告诉鼎汇丰或商家。\n' +
                '5.2 除另有特别说明外，本网站展示的商品的价格都为含税价格。送货运费需由您另行支付，当然，根据您选择的商品、价格、区域和送货方式不同，商家可能对运费进行适当减免。\n' +
                '六、订单成立及履约基本规则\n' +
                '6.1 在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。\n' +
                '6.2 如果因为您填写的收货人联系电话、地址等信息错误，导致商家（或商家委托的配送公司）将货物交付给非您本意的收货人的，由此造成的损失需由您自行承担。\n' +
                '6.3 用户同意鼎汇丰平台上的订单成立规则：\n' +
                '（1）鼎汇丰上销售方展示的商品以及其价格、规格等信息，其性质为要约邀请，是销售方希望您向其发出要约的意思表示。\n' +
                '（2）当您确定购买并成功提交订单时（您的订单内容应包含您希望购买的商品数量、价格及支付方式、收货人、联系方式、收货地址等信息），视为您向销售方发出了购买订单商品的要约；\n' +
                '（3）订单提交成功的信息是系统自动生成，并非商家对您要约的承诺。只有系统将订单信息反馈至销售方，经销售方确认能够满足您的订购需求并向您发货（以订单状态为准）时，方视为销售方对您的要约作出承诺，此时您与销售方之间就该已发货商品成立了合同关系；您可以通过查看系统显示的订单状态，了解您与销售方之间的合同是否成立以及成立的时间。\n' +
                '（4）如果您在一份订单里订购了多种商品并且销售方只给您发出了部分商品时，您与销售方之间仅就实际直接向您发出的商品建立了交易关系；只有在销售方实际直接向您发出了订单中订购的其他商品时，您和销售方之间就订单中该其他已实际直接向您发出的商品才成立合同关系。\n' +
                '（5）在销售方与您的买卖合同成立之前，您与销售方均有权取消相关商品的订单，订单取消后，您已支付的款项将退回您的付款账户。您可以随时登录您在本站注册的账户，查询您的订单状态。\n' +
                '6.4 销售方将尽量满足您的购物需求，避免您选购的商品无货，但是由于技术障碍以及各类销售方难以控制和避免的因素，销售方无法保证符合您提交的订单中所有要求的商品都有货；如您订购的商品无货，销售方将及时与您联系，您有权取消订单。\n' +
                '6.5 如您在购物过程中有任何疑问或与销售方产生纠纷的，您可以通过XX平台设立的客服渠道进行咨询和投诉。\n' +
                '七、配送\n' +
                '7.1 销售方将会把产品送到您所指定的配送地址。所有在鼎汇丰上列出的送货时间均为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的，参考时间不等同于到货时间。 送货费用根据您选择的配送方式及地区不同而异。 请准确清晰地填写您的真实姓名、送货地址及联系方式。\n' +
                '7.2 因如下情况造成订单延迟或无法配送等，销售方不承担迟延配送的责任，并保留单方取消订单的权利：\n' +
                '（1）客户提供错误信息和不详细的地址导致的；\n' +
                '（2）货物送达无人签收，导致无法配送或延迟配送的；\n' +
                '（3）情势变更因素导致的；\n' +
                '（4）不可抗力，例如：自然灾害、交通戒严、突发战争等。\n' +
                '八、责任限制\n' +
                '8.1 鼎汇丰依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，鼎汇丰并不承担相应的违约责任：\n' +
                '（1）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；\n' +
                '（2）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；\n' +
                '（3）在鼎汇丰已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。\n' +
                '8.2 用户明确了解并同意，使用本服务之风险由用户个人负担。除非另有明确的书面说明，本站及其所包含的或以其他方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和本服务，均是在"现状"和按"现有"基础提供的。\n' +
                '8.3 除非另有明确的书面说明，鼎汇丰不对网站的运营及其网站上的全部信息、内容、材料、产品（包括软件）或本服务作任何形式的明示或默示的担保或保证（根据中华人民共和国法律另有规定的除外）。\n' +
                '8.4 鼎汇丰对于任何自本网站而获得的他人的信息或者广告宣传等任何资讯（以下统称"信息"），不保证真实、准确和完整性。如果任何单位或者个人通过上述"信息"而进行任何行为，须自行甄别真伪和谨慎预防风险。否则，无论何种原因，本网站不对任何非与本网站直接发生的交易和/或行为承担任何直接、间接、附带或衍生的损失和责任。\n' +
                '8.5 您理解并同意，在争议调处服务中，鼎汇丰平台的客服并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意或重大过失外，调处方对争议调处决定免责。\n' +
                '九、用户信息的保护及授权\n' +
                '9.1 您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，鼎汇丰可对您发布的信息依法或依本协议进行删除或屏蔽。\n' +
                '9.2 鼎汇丰保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在鼎汇丰的非公开内容，但下列情况除外：\n' +
                '（1）事先获得您的明确授权；\n' +
                '（2）系为履行您的订单或保护您的合法权利所必须；\n' +
                '（3）相应的法律程序及相关政府部门要求鼎汇丰提供的。\n' +
                '9.3 鼎汇丰可能会与第三方合作向用户提供相关的网络服务，同时，为了更好向用户提供服务、推荐产品及开展市场调查与信息数据分析等，鼎汇丰可能需要向合作方披露用户相关信息，在此情况下，鼎汇丰有权将用户的相关信息提供给该第三方。\n' +
                '9.4 在不透露单个用户隐私资料的前提下，鼎汇丰有权对用户数据库进行分析并对用户数据库进行商业上的利用。\n' +
                '9.5 为方便您使用鼎汇丰的物流、金融、通讯等相关服务，您同意并授权鼎汇丰将您在账户注册和使用XX平台服务过程中提供、形成的信息传递给鼎汇丰平台的其他相关服务提供者，或从鼎汇丰平台其他相关服务提供者获取您在注册、使用相关服务期间提供、形成的信息。您同意不会因此追究鼎汇丰平台相关服务提供者的责任。\n' +
                '十、知识产权\n' +
                '10.1 鼎汇丰作为鼎汇丰平台的运营商，拥有鼎汇丰平台内容及资源的著作权等合法权利，受国家法律保护。\n' +
                '10.2鼎汇丰提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护。未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人用途而保存在某台计算机内。鼎汇丰不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害，以任何形式向用户或任何第三方负法律责任。\n' +
                '十一、通知及送达\n' +
                '11.1 您在注册成为鼎汇丰平台用户，并接受鼎汇丰平台服务时，您应该向鼎汇丰提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。\n' +
                '您在注册鼎汇丰平台用户时生成的用于登陆鼎汇丰平台接收消息的会员账号，也作为您的有效联系方式。\n' +
                '11.2 鼎汇丰将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。\n' +
                '11.3 鼎汇丰通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在鼎汇丰平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的客户端推送的消息、系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。\n' +
                '11.4 你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，由您自行承担由此可能产生的法律后果。\n' +
                '十二、协议的变更、终止\n' +
                '12.1 根据国家相关法律法规及政策变化或网站运营需要，鼎汇丰有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议；用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受鼎汇丰网站依据本协议提供的服务, 变更事项对您不产生效力；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。鼎汇丰建议您在使用本站之前阅读本协议及本站的公告。\n' +
                '12.2 您有权通过以下任一方式终止本协议：\n' +
                '（1）您通过网站自助服务注销您的账户的；\n' +
                '（2）变更事项生效前您停止使用并明示不愿接受变更事项的；\n' +
                '（3）您明示不愿继续使用鼎汇丰平台服务，且符合鼎汇丰网终止条件的。\n' +
                '12.3 出现以下情况时，鼎汇丰可以本协议所列的方式通知您终止本协议：\n' +
                '（1）您违反本协议约定，鼎汇丰依据违约条款终止本协议的；\n' +
                '（2）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，鼎汇丰依据鼎汇丰平台规则对您的账户予以查封的；\n' +
                '（3）除上述情形外，因您多次违反鼎汇丰平台规则相关规定且情节严重，鼎汇丰依据鼎汇丰平台规则对您的账户予以查封的；\n' +
                '（4）其它应当终止服务的情况。\n' +
                '12.4 本协议终止后，除法律有明确规定外，鼎汇丰无义务向您或您指定的第三方披露您账户中的任何信息。且鼎汇丰仍享有下列权利：\n' +
                '（1）继续保存您留存于鼎汇丰平台的各类信息；\n' +
                '（2）对于您过往的违约行为，鼎汇丰仍可依据本协议向您追究违约责任。\n' +
                '12.5 本协议终止后，对于您在本协议存续期间产生的交易订单，鼎汇丰可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。\n' +
                '十三、法律适用\n' +
                '13.1 本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。\n' +
                '13.2 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。\n' +
                '十四、争议\n' +
                '您因使用鼎汇丰平台服务所产生及与平台服务有关的争议，由鼎汇丰与您协商解决。协商不成时，任何一方均可向甲方所在地人民法院提起诉讼。\n',
        radio: 1
      }
    },
    created () {
      this.$toast.clear()
      // this.$router.replace({path: '/login', query: {type: Math.random().toString()}})
      // this.getCode('123')
      // if (window.history && window.history.pushState) {
      //   history.pushState(null, null, document.URL)
      //   window.addEventListener('popstate', this.goBack, false)
      // }
    },
    destroyed () {
      // window.removeEventListener('popstate', this.goBack, false)
    },
    methods: {
      goBack () {
        this.$router.replace({path: '/'})
      },
      changeRadio () {
        this.form =  {
           recommendCode: '',
            userName: '',
            passwd: '',
            userTel: '',
            address: '',
            orgNo: '',
            contactUser: '',
            isAgreed: ''
        }
      },
      formatSpace (val) {
        this.form[val] = this.form[val].replace(/ /g, '')
      },
      createGysUser () {
        this.$toast.loading({
          duration: 0
        })
        let self = this
        self.$request.login.createGysUser({
          ...self.form,
          isAgreed: 1,
          passwd: md5(self.form.passwd)
        })
                .then((response) => {
                  this.$toast.clear()
                  self.$toast(response.msg)
                  if (response.code === '200') {
                    setTimeout(function () {
                      self.$router.push('/login')
                    }, 300)
                  } else {
                  }
                })
      },
      createHsbcOperator () {
        this.$toast.loading({
          duration: 0
        })
        let self = this
        self.$request.login.createHsbcOperator({
          ...self.form,
          isAgreed: 1,
          passwd: md5(self.form.passwd)
        })
                .then((response) => {
                  this.$toast.clear()
                  self.$toast(response.msg)
                  if (response.code === '200') {
                    setTimeout(function () {
                      self.$router.push('/login')
                    }, 300)
                  } else {
                  }
                })
      },
      createDzUser () {
        this.$toast.loading({
          duration: 0
        })
        let self = this
        self.$request.login.createDzUser({
          ...self.form,
          isAgreed: 1,
          passwd: md5(self.form.passwd)
        })
                .then((response) => {
                  this.$toast.clear()
                  self.$toast(response.msg)
                  if (response.code === '200') {
                    setTimeout(function () {
                      self.$notify.clear()
                      self.$router.push('/login')
                    }, 300)
                  } else {
                  }
                })
      },
      onSubmit () {
        const self = this
        self.$refs.MyForm.validate()
                .then(() => {
                  if (this.radio === 1) {
                    if (!this.form.isAgreed) {
                      this.$toast('请阅读并勾选服务协议')
                    } else {
                      this.createDzUser()
                    }
                  } else if (this.radio === 2) {
                    if (!this.form.isAgreed) {
                      this.$toast('请阅读并勾选服务协议')
                    } else {
                      this.createGysUser()
                    }
                  } else if (this.radio === 3) {
                      this.createHsbcOperator()
                  }
                }).catch((error) => {
        })
      },
      goRegister () {
        this.$router.push({name: 'Register'})
      },
      goForget () {
        this.$router.push({name: 'Forget'})
      },
      onClickLeft () {
        this.$router.replace({path: '/'})
      }
    }
  }
</script>

<style>
  .loginForm .van-cell::after{
    border: none;
  }
  .loginFormItem {
    display: flex;width: calc(72vw - 5.8vw);margin: 31px auto;
    border-radius: 51px;overflow: hidden;
    padding-left: 5.8vw;
  }
  .loginFormItem.active {
    box-shadow: 0px 4px 45px 0px rgba(244,93,89,0.14);
  }
</style>
